import { createContext, FC, useContext, useEffect } from 'react';
import { AuthContext, CommonContext } from '@repo-level/core-front';

import { groupMemberDepositor } from 'helpers/user';
import { localStorageStag } from 'modules/userTrackingParams';

const HotjarContext = createContext<{}>(null as any);

export const HotjarContextProvider: FC = ({ children }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const { currentIp } = useContext(CommonContext);

  useEffect(() => {
    if (isAuthenticated) {
      try {
        // @ts-ignore
        window?.hj('identify', user?.id || null, {
          email: user?.email || null,
          depositor: groupMemberDepositor(user) ? 'YES' : 'NO',
          groups: user?.statuses?.map(({ id }) => id).join(', ') || null,
          stag: localStorageStag.get(),
        });
      } catch {}
    }
  }, [currentIp, isAuthenticated, user]);

  return <HotjarContext.Provider value={{}}>{children}</HotjarContext.Provider>;
};
